import React, { useState, useEffect } from 'react';
import { hasPermission, FEATURE_PERMISSIONS } from '../../utils/permissions';
import { useAuth } from '../auth/AuthContext';

const LocationModal = ({
  open,
  location,
  onClose,
  onSave,
  isEditing = true,
}) => {
  const { currentUser } = useAuth();
  const [form, setForm] = useState(location || {});

  useEffect(() => {
    setForm(location || {});
  }, [location, open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg">
        <h2 className="text-lg font-bold mb-4">{isEditing ? 'Edit Location' : 'Add Location'}</h2>
        <form
          onSubmit={e => {
            e.preventDefault();
            if (!hasPermission(currentUser, FEATURE_PERMISSIONS.CUSTOMER_EDIT)) return;
            onSave(form);
          }}
        >
          <div className="mb-3">
            <label className="block font-semibold mb-1">Store Name <span className="text-red-600">*</span></label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.locationName || ''}
              onChange={e => setForm(f => ({ ...f, locationName: e.target.value }))}
              placeholder="Location Name"
              required
            />
          </div>
          <div className="mb-3">
            <label className="block font-semibold mb-1">Address 1 <span className="text-red-600">*</span></label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.locationAddress1 || ''}
              onChange={e => setForm(f => ({ ...f, locationAddress1: e.target.value }))}
              placeholder="Address 1"
              required
            />
          </div>
          <div className="mb-3">
            <label className="block font-semibold mb-1">Address 2</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.locationAddress2 || ''}
              onChange={e => setForm(f => ({ ...f, locationAddress2: e.target.value }))}
              placeholder="Address 2"
            />
          </div>
          <div className="mb-3">
            <label className="block font-semibold mb-1">City <span className="text-red-600">*</span></label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.locationCity || ''}
              onChange={e => setForm(f => ({ ...f, locationCity: e.target.value }))}
              placeholder="City"
              required
            />
          </div>
          <div className="mb-3">
            <label className="block font-semibold mb-1">State <span className="text-red-600">*</span></label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.locationState || ''}
              onChange={e => setForm(f => ({ ...f, locationState: e.target.value }))}
              placeholder="State"
              required
            />
          </div>
          <div className="mb-3">
            <label className="block font-semibold mb-1">Zip <span className="text-red-600">*</span></label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.locationZip || ''}
              onChange={e => setForm(f => ({ ...f, locationZip: e.target.value }))}
              placeholder="Zip"
              required
            />
          </div>
          <div className="mb-3">
            <label className="block font-semibold mb-1">Country <span className="text-red-600">*</span></label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.locationCountry || ''}
              onChange={e => setForm(f => ({ ...f, locationCountry: e.target.value }))}
              placeholder="Country"
              required
            />
          </div>
          <div className="mb-3">
            <label className="block font-semibold mb-1">Phone</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.locationPhone || ''}
              onChange={e => setForm(f => ({ ...f, locationPhone: e.target.value }))}
              placeholder="Phone"
            />
          </div>
          <div className="mb-3">
            <label className="block font-semibold mb-1">Email</label>
            <input
              type="email"
              className="w-full border rounded px-3 py-2"
              value={form.locationEmail || ''}
              onChange={e => setForm(f => ({ ...f, locationEmail: e.target.value }))}
              placeholder="Email"
            />
          </div>
          <div className="mb-3 flex items-center">
            <input
              type="checkbox"
              id="mainLocation"
              checked={String(form.locationIsMainLocation) === '1' || String(form.locationIsMainLocation) === 'true'}
              onChange={e =>
                setForm(f => ({
                  ...f,
                  locationIsMainLocation: e.target.checked ? '1' : '0',
                }))
              }
              className="mr-2"
            />
            <label htmlFor="mainLocation" className="font-semibold">Main Location</label>
          </div>
          <div className="flex justify-end space-x-2 mt-6">
            <button
              type="button"
              className="px-4 py-2 bg-gray-300 text-gray-800 rounded"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 text-white rounded"
            >
              {isEditing ? 'Save Changes' : 'Add Location'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LocationModal;